module.exports = __webpack_public_path__ + "media/landing_page/social_network-33c08207.svg";